import { TableCore } from "@/types/list";
import { X } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { AnimatePresence, motion } from "framer-motion";

export const Selected = <TData,>({ table }: TableCore<TData>) => {
	const { rowSelection } = table.getState();
	const selectedCount = Object.values(rowSelection).filter(Boolean).length;

	const handleClear = () => {
		table.resetRowSelection();
	};

	return (
		<AnimatePresence mode="popLayout">
			{selectedCount > 0 && (
				<motion.div
					key="selected-banner"
					layout
					initial={{ opacity: 0, y: -6 }}
					animate={{ opacity: 1, y: 0 }}
					exit={{ opacity: 0, y: -20 }}
					transition={{ duration: 0.2, ease: "easeOut" }}
					className="inline-flex items-center gap-1 rounded-md bg-primary/5 py-1 text-xs text-primary"
				>
					<span>
						Selected rows: <span className="font-medium">{selectedCount}</span>
					</span>

					<Tooltip>
						<TooltipTrigger asChild>
							<button
								type="button"
								onClick={handleClear}
								className="ml-1 text-red-500 transition-colors hover:text-red-600"
							>
								<X className="h-4 w-4" aria-hidden="true" />
							</button>
						</TooltipTrigger>

						<TooltipContent side="right">Unselect all</TooltipContent>
					</Tooltip>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
